export const BuildingGroupTableCellName = {
  Buildings: 'buildings',
  CreatedAt: 'created',
  CreatedBy: 'created_by',
  ExternalId: 'external_id',
  FlatsCount: 'flat_count',
  InhabitantCount: 'inhabitant_count',
  ResponsibleManager: 'responsible_users',
  Title: 'name',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
}
